import React from "react";

function StepProgressUI({ currentStep = 1, onStepChange }) {
  const steps = ["Address", "Order Summary", "Payment"];

  return (
    <>
      <style>{`
        .steps {
          display: flex;
          align-items: center;
        }

        .step {
          text-align: center;
          position: relative;
          cursor: pointer;
        }

        .circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px solid #d1d5db;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: auto;
          background: white;
          color: #9ca3af;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .step p {
          margin-top: 6px;
          font-size: 14px;
          color: #9ca3af;
        }

        .line {
          width: 120px;
          height: 3px;
          background: #e5e7eb;
          margin: 0 10px;
          position: relative;
          overflow: hidden;
        }

        .line.active::after {
          content: "";
          position: absolute;
          height: 100%;
          width: 100%;
          background: radial-gradient(circle at top, #1a2a2a, #0f1a1a, #0a0f0f);
          left: -100%;
          animation: slide 0.5s forwards;
        }

        @keyframes slide {
          to { left: 0; }
        }

        .completed .circle {
          border-color: #1a2a2a;
          color: #1a2a2a;
        }

        .completed p {
          color: #374151;
        }

        .active .circle {
          background: radial-gradient(circle at top, #1a2a2a, #0f1a1a, #0a0f0f);
          color: white;
          border-color: #1a2a2a;
          transform: scale(1.1);
        }

        .active p {
          color: #111827;
          font-weight: 600;
        }

        @media (max-width: 600px) {
          .steps {
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: space-between;
          }

          .line {
            width: 120px;
            height: 3px;
            background: #e5e7eb;
            margin: 0 10px;
            position: relative;
            overflow: hidden;
          }
        }
      `}</style>

      <div className="steps">
        {steps.map((label, index) => {
          const stepNumber = index + 1;

          const status =
            currentStep > stepNumber
              ? "completed"
              : currentStep === stepNumber
                ? "active"
                : "";

          return (
            <React.Fragment key={index}>
              <div
                className={`step ${status}`}
                onClick={() => onStepChange && onStepChange(stepNumber)}
              >
                <div className="circle">
                  {currentStep > stepNumber ? "✓" : stepNumber}
                </div>
                <p>{label}</p>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`line ${currentStep > stepNumber ? "active" : ""}`}
                ></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}

export default StepProgressUI;
